/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sold: NonNullable<unknown>, total: NonNullable<unknown> }} Ticketpagesoldof3Inputs */

const en_ticketpagesoldof3 = /** @type {(inputs: Ticketpagesoldof3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} of ${i?.total}`)
};

const de_ticketpagesoldof3 = /** @type {(inputs: Ticketpagesoldof3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sold} von ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{sold} of {total}" |
*
* @param {Ticketpagesoldof3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagesoldof3 = /** @type {((inputs: Ticketpagesoldof3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagesoldof3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagesoldof3(inputs)
	return de_ticketpagesoldof3(inputs)
});
export { ticketpagesoldof3 as "ticketPageSoldOf" }